export default __webpack_public_path__ + "static/media/sidebar-background.6fd2ab85.jpg";